import LeftRobotCard from './common/LeftRobotCard'
import useWindowSize from 'components/util/useWindowSize'

const WhyChooseEnterpriseCard = () => {
  const size = useWindowSize()
  return (
    <LeftRobotCard
      reverseColumnOrder
      image={{
        alt: 'Robot middle section',
        desktop: {
          dimensions: {
            height: 400,
            width: 500,
          },
          src: '/images/new/robot-middle-cut.png',
        },
        mobile: {
          dimensions: {
            height: 500,
            width: 400,
          },
          src: '/images/new/robot-middle-cut-mobile.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '50%' : '100%'}
      imageStyle={{
        maxHeight: '100%',
        maxWidth: '100%',
        objectFit: 'cover',
        objectPosition: 'right',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-2 px-4 pt-4 pb-5 pe-lg-8 py-lg-19'>
        <h3 className='fw-semibold fs-fluid-36-52'>
          Why Choose Our Enterprise Solutions?
        </h3>
        <div className='fw-semibold lh-132 fs-fluid-18-28'>
          100+ banks, accountancy firms, and businesses trust our virtual office
          SaaS solutions.
        </div>
        <div className='fw-semibold lh-132 fs-fluid-16-22'>
          Our expertise in the financial sector and modern REST API enable
          seamless integration with your platform. Our integration options are
          built on experience, and a restless approach to understanding our
          Partners needs.{' '}
        </div>
      </div>
    </LeftRobotCard>
  )
}

export default WhyChooseEnterpriseCard
